import { CommonModule } from "@angular/common";
import { Component, computed, effect, inject, input, InputSignal } from "@angular/core";
import { AppService } from "src/services/app.service";
import { VUserComponent } from "../v-user/v-user.component";
import { SkeletonModule } from "primeng/skeleton";

@Component({
    selector:    'v-entity',
    styleUrls:   ['./v-entity.component.sass'],
    templateUrl: './v-entity.component.haml',
    imports:     [CommonModule, VUserComponent, SkeletonModule],
    standalone:  true
})
export class VEntityComponent {
    app = inject(AppService);

    entityID: InputSignal<string> = input();

    userID = computed(() => !this.entityID()?.includes('#') ? this.entityID() : undefined);
    departmentID = computed(() => this.entityID()?.includes('#') ? this.entityID().split('#')[0] : undefined);
    entityType = computed(() => {
        if (!this.entityID())
            return undefined;
        if (!this.entityID().includes('#'))
            return 'user';
        if (this.entityID().endsWith('#H'))
            return 'head';
        return 'member';
    });

    user = computed(() => this.userID() ? this.app.userSyncService.get(this.userID()) : undefined);
    department = computed(() => this.departmentID() ? this.app.departmentSyncService.get(this.departmentID()) : undefined);

    constructor() {
        effect(() => {
            console.log("v-entity: ", this.entityType(), this.department(), this.department()?.value());
        });
    }
}